 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];
 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);
 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"common":"common","views-finance-expenses-expenses-module":"views-finance-expenses-expenses-module","views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06":"views-configuration-fiscal-spans-fiscal-period-updates-module~views-ecommerce-configuration-configur~0f61ff06","views-configuration-fiscal-spans-fiscal-period-updates-module":"views-configuration-fiscal-spans-fiscal-period-updates-module","views-configuration-management-management-module":"views-configuration-management-management-module","views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508":"views-configuration-security-security-module-module~views-ecommerce-configuration-configuration-modu~46da6508","views-configuration-security-security-module-module":"views-configuration-security-security-module-module","views-finance-Reports-analytic-group-analytic-group-module":"views-finance-Reports-analytic-group-analytic-group-module","views-procurement-loyalty-loyalty-module":"views-procurement-loyalty-loyalty-module","views-restaurant-order-management-order-management-module":"views-restaurant-order-management-order-management-module","views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2":"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-configuration-configura~d79f83f2","views-ecommerce-delivery-management-delivery-management-module":"views-ecommerce-delivery-management-delivery-management-module","views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-promotions-promotions-m~af66c750":"views-ecommerce-catalog-management-catalog-management-module~views-ecommerce-promotions-promotions-m~af66c750","views-ecommerce-promotions-promotions-module":"views-ecommerce-promotions-promotions-module","views-reportprint-report-print-module~views-restaurant-catalog-management-catalog-management-module~~7c64928d":"views-reportprint-report-print-module~views-restaurant-catalog-management-catalog-management-module~~7c64928d","views-restaurant-catalog-management-catalog-management-module":"views-restaurant-catalog-management-catalog-management-module","views-restaurant-core-core-module":"views-restaurant-core-core-module","views-configuration-tax-setup-tax-setups-module":"views-configuration-tax-setup-tax-setups-module","views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec":"views-dashboard-dashboard-module~views-finance-Reports-summary-summary-reports-module~views-finance-~cfa48eec","views-dashboard-dashboard-module":"views-dashboard-dashboard-module","views-ecommerce-buyer-management-buyer-management-module":"views-ecommerce-buyer-management-buyer-management-module","views-ecommerce-orders-orders-module":"views-ecommerce-orders-orders-module","views-ecommerce-catalog-management-catalog-management-module":"views-ecommerce-catalog-management-catalog-management-module","views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3":"views-ecommerce-configuration-configuration-module~views-finance-Reports-Ledgers-Statements-generic-~4d13b3a3","views-finance-banking-banking-module":"views-finance-banking-banking-module","views-finance-cheques-incoming-cheques-module":"views-finance-cheques-incoming-cheques-module","views-finance-earnings-earnings-module":"views-finance-earnings-earnings-module","views-finance-finance-setup-finance-setup-module":"views-finance-finance-setup-finance-setup-module","views-finance-payments-payments-module":"views-finance-payments-payments-module","views-pos-pos-module":"views-pos-pos-module","views-procurement-banking-banking-module":"views-procurement-banking-banking-module","views-procurement-barcode-barcode-module":"views-procurement-barcode-barcode-module","views-procurement-master-master-module":"views-procurement-master-master-module","views-procurement-offere-discount-offere-discount-module":"views-procurement-offere-discount-offere-discount-module","views-procurement-purchase-purchase-module":"views-procurement-purchase-purchase-module","views-finance-Reports-Ledgers-Statements-generic-statements-module":"views-finance-Reports-Ledgers-Statements-generic-statements-module","views-finance-Reports-listings-audit-reports-module":"views-finance-Reports-listings-audit-reports-module","views-pos-point-of-sales-setups-point-of-sales-setups-module":"views-pos-point-of-sales-setups-point-of-sales-setups-module","views-procurement-Reports-acquisition-acquisition-module":"views-procurement-Reports-acquisition-acquisition-module","views-procurement-Reports-invoices-reports-invoices-reports-module":"views-procurement-Reports-invoices-reports-invoices-reports-module","views-procurement-Reports-order-reports-order-reports-module":"views-procurement-Reports-order-reports-order-reports-module","views-procurement-Reports-payments-reports-payments-reports-module":"views-procurement-Reports-payments-reports-payments-reports-module","views-procurement-Reports-procurment-reports-procurment-reports-module":"views-procurement-Reports-procurment-reports-procurment-reports-module","views-procurement-Reports-sales-reports-sales-reports-module":"views-procurement-Reports-sales-reports-sales-reports-module","views-procurement-Reports-stocks-reports-stocks-reports-module":"views-procurement-Reports-stocks-reports-stocks-reports-module","views-procurement-Reports-tax-reports-tax-reports-module":"views-procurement-Reports-tax-reports-tax-reports-module","views-restaurant-setting-setting-module":"views-restaurant-setting-setting-module","views-procurement-sales-sales-module":"views-procurement-sales-sales-module","views-procurement-setup-procurement-setup-module":"views-procurement-setup-procurement-setup-module","views-ecommerce-configuration-configuration-module":"views-ecommerce-configuration-configuration-module","views-finance-Reports-summary-summary-reports-module":"views-finance-Reports-summary-summary-reports-module","views-finance-accounts-accounts-module~views-procurement-business-partners-business-partners-module~~26e5ccbb":"views-finance-accounts-accounts-module~views-procurement-business-partners-business-partners-module~~26e5ccbb","views-finance-accounts-accounts-module":"views-finance-accounts-accounts-module","views-procurement-stock-pile-management-stock-pile-management-module":"views-procurement-stock-pile-management-stock-pile-management-module","views-finance-transactions-transactions-module":"views-finance-transactions-transactions-module","views-procurement-partner-directory-partner-directory-module":"views-procurement-partner-directory-partner-directory-module","views-procurement-business-partners-business-partners-module":"views-procurement-business-partners-business-partners-module","views-finance-invoicing-invoicing-module~views-finance-notes-notes-module~views-reportprint-report-p~efc2f562":"views-finance-invoicing-invoicing-module~views-finance-notes-notes-module~views-reportprint-report-p~efc2f562","views-finance-invoicing-invoicing-module":"views-finance-invoicing-invoicing-module","views-finance-notes-notes-module":"views-finance-notes-notes-module","views-ecommerce-content-management-content-management-module":"views-ecommerce-content-management-content-management-module","views-ecommerce-coupon-management-coupon-management-module":"views-ecommerce-coupon-management-coupon-management-module","views-ecommerce-discount-management-discount-management-module":"views-ecommerce-discount-management-discount-management-module","views-ecommerce-setting-setting-module":"views-ecommerce-setting-setting-module","views-reportprint-report-print-module":"views-reportprint-report-print-module","views-pos-order-management-order-management-module":"views-pos-order-management-order-management-module"}[chunkId]||chunkId) + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var head = document.getElementsByTagName('head')[0];
 				var script = document.createElement('script');

 				script.charset = 'utf-8';
 				script.timeout = 120;

 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				function onScriptComplete(event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, {
 				configurable: false,
 				enumerable: true,
 				get: getter
 			});
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
